import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { BookOpen, ChevronRight, Heart } from 'lucide-react';
import PageWrapper from '../components/PageWrapper';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LearnPage = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showWomensHealth, setShowWomensHealth] = useState(false);

  useEffect(() => {
    const loadArticles = async () => {
      try {
        const response = await axios.get(`${API}/blog?limit=60`);
        setArticles(response.data);
      } catch (error) {
        console.error("Error loading articles:", error);
      } finally {
        setLoading(false);
      }
    };
    loadArticles();
  }, []);

  // Filter for Women's Health articles
  const filteredArticles = showWomensHealth 
    ? articles.filter(article => 
        article.category === "Womens Health" || 
        article.category === "Women's Health" ||
        article.title.toLowerCase().includes('women') ||
        article.title.toLowerCase().includes('incontinence') ||
        article.title.toLowerCase().includes('prolapse') ||
        article.title.toLowerCase().includes('menopause') ||
        article.title.toLowerCase().includes('oab') ||
        article.title.toLowerCase().includes('overactive bladder')
      )
    : articles;

  if (loading) {
    return (
      <PageWrapper>
        <div className="loading-state" data-testid="loading-state">
          <div className="spinner"></div>
          <p>Loading educational content...</p>
        </div>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <div className="page-header-simple" data-testid="learn-header">
        <h2>Learn About Urologic Conditions</h2>
        <p>Evidence-based information reviewed by board-certified urologists</p>
      </div>

      {/* Women's Health Filter Button */}
      <div className="library-filter-section" data-testid="library-filters">
        <button
          className={`womens-health-filter-btn ${showWomensHealth ? 'active' : ''}`}
          onClick={() => setShowWomensHealth(!showWomensHealth)}
          data-testid="womens-health-filter-btn"
        >
          <Heart size={18} />
          Women's Health
          {showWomensHealth && <span className="filter-count">({filteredArticles.length})</span>}
        </button>
        {showWomensHealth && (
          <button 
            className="clear-filter-btn"
            onClick={() => setShowWomensHealth(false)}
            data-testid="clear-filter-btn"
          >
            Show All Articles
          </button>
        )}
      </div>

      <div className="articles-list" data-testid="articles-list">
        {filteredArticles.length > 0 ? (
          filteredArticles.map(article => (
            <Link 
              to={`/learn/${article.id}`} 
              key={article.id} 
              className="article-card"
              data-testid={`article-card-${article.id}`}
            >
              <div className="article-card-content">
                <h3>{article.title}</h3>
                <p className="article-category">{article.category}</p>
                <span className="read-more">Read More <ChevronRight size={16} /></span>
              </div>
            </Link>
          ))
        ) : (
          <div className="empty-state" data-testid="empty-state">
            <BookOpen size={48} />
            <p>Educational content coming soon</p>
          </div>
        )}
      </div>
    </PageWrapper>
  );
};

export default LearnPage;
